.popover {
    outline: none;
    box-sizing: border-box;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    max-width: var(--popover-max-width, 300px);
    min-width: var(--popover-min-width, auto);
    /* Establish a stacking context so BaseOverlayArrow's z-index: -1 stays contained here — the
       arrow paints above this element's background (seamless pointer) but below in-flow text
       (so the overlap strip inside the popover doesn't obscure content). */
    isolation: isolate;
}

.popover.light {
    background-color: var(--colorSurfacePrimary);
}

.popover.dark {
    background-color: var(--colorSurfacePopoverDark);
}

.popover.default {
    padding: var(--base-popover-padding, var(--spacing-md))
}

.popover.tight {
    padding: var(--base-popover-padding, var(--spacing-sm))
}

.popover[data-entering] {
    animation: var(--animation-slide-in) var(--animation-slide-delay) var(--spring-1);
}

.popover[data-exiting] {
    animation: var(--animation-slide-out) var(--animation-slide-delay) var(--spring-1);
}

.arrow {
    display: block;
    /* fill: var(--colorSurfacePrimary); */
}
